module.exports = __webpack_public_path__ + "static/hydroloth-6905d58014f6e1b7690e83d8b2f3afcd.png";